import { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";

// eslint-disable-next-line react/prop-types
const PurchaseForm = ({ setUserData, setTermsyconditions, termsyconditions }) => {
    const [email, setEmail] = useState("");
    const [confirmEmail, setConfirmEmail] = useState("");
    const [dni, setDni] = useState("");
    const [phone, setPhone] = useState("");
    const [name, setName] = useState("");
    const [lastName, setLastName] = useState("");
    const { isAuthenticated, user } = useAuth();

    useEffect(() => {
        const userData = { email, lastName, dni, name, phone, confirmEmail };
        setUserData(userData);
    }, [
        email,
        dni,
        name,
        lastName,
        phone,
        confirmEmail,
        isAuthenticated,
        setUserData,
    ]);

    useEffect(() => {
        if (isAuthenticated) {
            setName(user.name);
            setLastName(user.lastName);
            setEmail(user.email);
            setConfirmEmail(user.email);
            setDni(user.dni);
            setPhone(user.phone);
        }
    }, [isAuthenticated, user]);

    const handleSetPhone = (value) => {
        let phone = value;
        if (phone.startsWith("0")) {
            phone.slice(1);
        }
        setPhone(phone);
    };

    return (
        <form
            className="space-y-4 max-w-lg m-auto bg-zinc-900 p-6 rounded-sm mt-8 font-sans"
            autoComplete="yes"
        >
            <div>
                <label htmlFor="name" className="block text-sm font-medium ">
                    Nombre
                </label>
                <input
                    id="name"
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="mt-1 block w-full px-3 py-2  rounded-md shadow-sm bg-zinc-800"
                />
            </div>
            <div>
                <label
                    htmlFor="lastName"
                    className="block text-sm font-medium "
                >
                    Apellido
                </label>
                <input
                    id="lastName"
                    type="text"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    className="mt-1 block w-full px-3 py-2  rounded-md shadow-sm bg-zinc-800"
                />
            </div>
            <div>
                <label htmlFor="email" className="block text-sm font-medium ">
                    Email
                </label>
                <input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="mt-1 block w-full px-3 py-2  rounded-md shadow-sm bg-zinc-800"
                />
            </div>
            <div>
                <label
                    htmlFor="confirmEmail"
                    className="block text-sm font-medium "
                >
                    Confirmar Email
                </label>
                <input
                    id="confirmEmail"
                    type="email"
                    value={confirmEmail}
                    onChange={(e) => setConfirmEmail(e.target.value)}
                    className="mt-1 block w-full px-3 py-2  rounded-md shadow-sm bg-zinc-800"
                />
            </div>
            <div>
                <label htmlFor="dni" className="block text-sm font-medium ">
                    Dni
                </label>
                <input
                    id="dni"
                    name="dni"
                    type="number"
                    autoComplete="id-number"
                    value={dni}
                    min={0}
                    onChange={(e) => setDni(e.target.value)}
                    className="mt-1 block w-full px-3 py-2  rounded-md shadow-sm bg-zinc-800"
                />
                <span className="text-zinc-400 text-sm">
                    Sin puntos ni comas
                </span>
            </div>
            <div>
                <label htmlFor="phone" className="block text-sm font-medium ">
                    Celular
                </label>
                <input
                    id="phone"
                    type="number"
                    placeholder="Ej: 2355212121"
                    value={phone}
                    min={0}
                    onChange={(e) => handleSetPhone(e.target.value)}
                    className="mt-1 block w-full px-3 py-2  rounded-md shadow-sm bg-zinc-800"
                />
                <span className="text-zinc-400 text-sm">
                    Sin el 0 y sin el 15
                </span>
            </div>
            <div className="flex gap-2">
                <input
                    id="terminos"
                    type="checkbox"
                    checked={termsyconditions}
                    onChange={() => setTermsyconditions(prev => !prev)}
                />
                <p>Acepto los </p>{" "}
                <a
                    href="/terminos-y-condiciones.html"
                    className="text-yellow-cdg"
                >
                    Terminos y condiciones
                </a>
            </div>
        </form>
    );
};

export default PurchaseForm;
